module.exports = __webpack_public_path__ + "img/scenes_10.7940b11e.png";